const entity = {
  TYPE_REPORT:{
    CONSOLIDATED:{resource:'consolidated', nameFile:'reporte-consolidado-'},
    SIMPLIFIED:{resource:'simplified', nameFile:'reporte-simplificados-'},
    CONFECCTIONATED:{resource:'made', nameFile:'reporte-confeccionado-'}
  },
  COLUMS_BY_ID_ACOUNT:[
    { 
      acountId:1,
      columns : function(roleId){return[
        { id: 'countPay', label: 'Pago', minWidth: '1%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'nameCliente', label: 'Cliente', minWidth: '2%', display: { xs: 'table-cell', sm: 'table-cell' } },
        { id: 'debtorName', label: 'Apellidos Deudor', minWidth: '2%', display: { xs: 'table-cell', sm: 'table-cell' } },
        { id: 'caseNumber', label: 'Juicio', minWidth: '2%', display: { xs: 'table-cell', sm: 'table-cell' } },
        { id: 'caseType', label: 'Tipo', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'workFlowState', label: 'Estado/Judicial', minWidth: '20%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'activityLastDate', label: 'Fecha', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'activityLast', label: 'Gestión Realizada', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'garmentState', label: 'Estado/Prenda	', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'court', label: 'Tribunal Asiganción', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        { id: 'rolNumber', label: 'Rol Asignación', minWidth: '2%', display: { xs: 'none', sm: 'table-cell' } },
        roleId !==10 && { id: 'selectActivitys', label: 'Próxima gestión', minWidth: '4%', display: { xs: 'table-cell', sm: 'table-cell' } },
        { id: 'selectActions', label: 'Acciones', minWidth: '4%', display: { xs: 'none', sm: 'table-cell' } }
      ]},
      forms:[
        {
          name:'search',
          form:function(getAllClient, workFlowStates, workFlowActivities, dataCourt, nameClienteDefauld, roleId) {
            const formulario = [{
              name: 'search',
              groups: [
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  display:true,
                  fields: [
                    
                    roleId !==10 && {
                      id: 'nameCliente',
                      label: `Nombre de cliente`,
                      kind: 'fieldListSearch',
                      value:  nameClienteDefauld && getAllClient[0] && getAllClient[0].nameComapny,
                      options: getAllClient.map(item => ({ name: item.nameComapny, id: item.nameComapny })),
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'caseNumber',
                      label: 'Codigo Juicio',
                      kind: 'text',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'garmentState',
                      label: 'Estado de la prenda',
                      kind: 'fieldListSearch',
                      options: [{ name: 'No incautado', id: 'No incautado' }, { name: 'Si incautado', id: 'Si incautado' }],
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'workFlowState',
                      label: 'Estado Judicial',
                      kind: 'fieldListSearch',
                      options: workFlowStates.map(item => ({ name: item.name, id: item.name })),
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'debtorName',
                      label: 'Apellidos del deudor',
                      kind: 'text',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'activityLast',
                      label: 'Gestion',
                      kind: 'fieldListSearch',
                      options: workFlowActivities.map(item => ({ name: item.name, id: item.name })),
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'court',
                      label: 'Tribunal',
                      kind: 'fieldListSearch',
                      options: dataCourt.map(item => ({ name: item.name, id: item.name })),
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'rolNumber',
                      label: 'Rol',
                      kind: 'text',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'activityLastDate',
                      label: 'Ultima gestión',
                      kind: 'date',
                      size: { xs: 12, sm: 12, md: 12 }
                    }, {
                      id: 'from',
                      label: 'Desde',
                      kind: 'date',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'to',
                      label: 'Hasta',
                      kind: 'date',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                  ],
                }
              ],
            }];
            return(formulario);
          }
        },
        {
          name:'activity',
          form:function(nameActivity, idActivity, dataCourt, locationComuna) {
            const activityForm = [{
              name: 'activity',
              groups: [
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  display:true,
                  fields: [
                    {
                      id: 'activityUserDate',
                      label: `Fecha de ${nameActivity}`,
                      kind: 'date',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Presentación de demanda en corte de apelaciones
                  display:4===idActivity,
                  fields: [
                    {
                      id: 'courtId',
                      label: 'Nombre del Tribunal',
                      kind: 'fieldListSearch',
                      required: true,
                      options: dataCourt?.map(item => ({ name: item.name, id: item.id })),
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'comunaId',
                      label: 'Comuna del Tribunal',
                      kind: 'fieldListSearch',
                      required: true,
                      options: locationComuna?.map(item => ({ name: item.name, id: item.id })),
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    ,
                    {
                      id: 'numberRol',
                      label: 'Numero de ROL Presentacion de demanda en corte de apelaciones',
                      kind: 'text',
                      required: true,
                      value:'C-',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //terceria 2
                  //quiebra 3
                  // caseTypeId number
                  display:6===idActivity || 7===idActivity,
                  fields: [
                    {
                      id: 'caseTypeId',
                      label: 'caseTypeId',
                      kind: 'hidden',
                      value: 6===idActivity ? 2:3,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Mandamiento
                  //faculty boolean
                  display:11===idActivity,
                  fields: [
                    {
                      id: 'faculty',
                      label: '¿Tiene Facultades de Incautador?',
                      kind: 'list',
                      required: true,
                      options: [{ name: 'Si', id: true },{ name: 'No', id: false }],
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Exhorto introducido en tribunal foráneo 
                  //comunaId, numberRol
                  display: 36===idActivity,
                  fields: [
                    {
                      id: 'courtId',
                      label: 'Nombre del tribunal del Exhorto ',
                      kind: 'fieldListSearch',
                      required: true,
                      options: dataCourt?.map(item => ({ name: item.name, id: item.id })),
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    ,
                    {
                      id: 'numberRol',
                      label: 'Numero de ROL Presentacion de demanda en corte de apelaciones',
                      kind: 'text',
                      required: true,
                      value:'C/E-',
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Solicitud de designación de martillero definitivo
                  //name, email, direction, phone
                  display:27===idActivity,
                  fields: [
                    {
                      id: 'name',
                      label: 'Nombre del depositario',
                      kind: 'text',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'email',
                      label: 'Correo electronico',
                      kind: 'email',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'direction',
                      label: 'Direción',
                      kind: 'text',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'phone',
                      label: 'Teléfono',
                      kind: 'phone',
                      required: true,
                      validations: ['CL'],
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Exhorto con facultades despachado
                  //courtId,numberRol,repairDate,orderDate, opisitionDate,
                  display: 46===idActivity,
                  fields: [
                    {
                      id: 'courtId',
                      label: 'Ingresa nombre del tribunal del Exhorto',
                      kind: 'fieldListSearch',
                      required: true,
                      options: dataCourt?.map(item => ({ name: item.name, id: item.id })),
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    ,
                    {
                      id: 'numberRol',
                      label: 'Rol',
                      kind: 'text',
                      required: true,
                      value:'C/E-',
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'repairDate',
                      label: `Fecha del reparo`,
                      kind: 'date',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'orderDate',
                      label: `Fecha del cúmplase`,
                      kind: 'date',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    },
                    {
                      id: 'opisitionDate',
                      label: `fecha de oposición`,
                      kind: 'date',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  // Consignación de fondos  al tribunal
                  // depositDate, mount
                  display:51===idActivity || 60===idActivity || 61===idActivity || 64===idActivity || 65===idActivity,
                  fields: [ 
                    {
                      id: 'depositDate',
                      label: 'Fecha de deposito',
                      kind: 'date',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    ,
                    {
                      id: 'mount',
                      label: 'Monto de cheque',
                      kind: 'number',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Retiro de cheque del tribunal por fondos rematados
                  //mount
                  display:56===idActivity,
                  fields: [
                    {
                      id: 'mount',
                      label: 'Monto de cheque',
                      kind: 'number',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  //Total Pay
                  //amount
                  display:66===idActivity || 68===idActivity,
                  fields: [
                    {
                      id: 'mount',
                      label: 'Monto de cheque',
                      kind: 'number',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                    
                  ],
                },
                {
                  size: { xs: 12, sm: 12, md: 12 },
                  display:true,
                  fields: [
                    {
                      id: 'coment',
                      label: 'Comentario',
                      kind: 'textarea',
                      required: true,
                      size: { xs: 12, sm: 12, md: 12 }
                    }
                  ],
                },
              ],
            }];
            return activityForm
          }
        },
        {
          name:'searchUnique',
          form:function() {
            const formulario = [{
              name: 'search',
              groups: [
                {
                  size: { xs: 11, sm: 11, md: 11 },
                  display:true,
                  fields: [
                    {
                      id: 'unique',
                      label: 'Buscar...',
                      kind: 'text',
                      size: { xs: 11, sm: 11, md: 11 }
                    },
                  ],
                }
              ],
            }];
            return(formulario);
          }
        },
      ]

    }
  ]
};

export default entity;

/**
 * 
 * 
 case 4:
                    //Presentación de demanda en corte de apelaciones
                    await this.repository.createApelationCour(traza.id, activityMakeEntity.courtId!, activityMakeEntity.comunaId!, activityMakeEntity.idUserRol)
                    break;

                case 6: case 7:
                    //terceria
                    //quiebra
                    await this.repository.updateTypeCase(activityMakeEntity.idCase, activityMakeEntity.caseTypeId!)
                    break;

                case 11:
                    //Mandamiento
                    await this.repository.createCommandment(traza.id, activityMakeEntity.faculty!)
                    break;

                case 14:
                    //Envío de exhorto a receptor foráneo 
                    await this.repository.createForeignReceiverTypeEntity(activityMakeEntity.foreignReceiver!, traza.id)
                    break;

                case 15: case 36:
                    //Exhorto introducido en tribunal foráneo 
                    await this.repository.createExhortOnForeingCourt(traza.id, activityMakeEntity.numberRol!, activityMakeEntity.comunaId!)
                    break;

                case 27:
                    //Solicitud de designación de martillero definitivo
                    await this.repository.createJudicialDepository(activityMakeEntity.judicialDepository!, traza.id, activityMakeEntity.idCase)
                    break;

                case 35: case 46:
                    //Exhorto con facultades despachado
                    await this.repository.createCourtManagement(activityMakeEntity.courtManagement!)
                    break;

                case 40:
                    //registra incautacion
                    await this.repository.updateStateGarament(activityMakeEntity.garmentId!, 2, traza.id)
                    break;


                case 51: case 60: case 61: case 64: case 65:
                    // Consignación de fondos  al tribunal
                    await this.repository.createDepositPay(traza.id, activityMakeEntity.depositDate!, activityMakeEntity.mount!)
                    break;


                case 56:
                    //56 Retiro de cheque del tribunal por fondos rematados
                    await this.repository.createCheckWithdrawal(traza.id, activityMakeEntity.mount!)
                    break;


                case 66: case 68:
                    // 66, 68 Total Pay
                    activityMakeEntity.pay!.trazaId=traza.id;
                    activityMakeEntity.pay!.caseId=activityMakeEntity.idCase
                    activityMakeEntity.pay!.userId=idUserToken;
                    await this.repository.createTotalPay(activityMakeEntity.pay!)
                    break;

                // ... more cases
 * 
 */
